import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import SectionHeading from '../../components/SectionHeading';
import { ease } from '../../utils/animations';

const paragraphSx = { fontSize: '1.02rem', lineHeight: 1.75, color: 'text.secondary', maxWidth: 520, m: 0 };

// Two paragraphs as two columns: an editorial layout that fills the width
// without a photo or a fact list. Stacks on phones.
const AboutSection = () => (
    <Box
        id="about"
        component="section"
        sx={{ py: { xs: 9, md: 13 }, scrollMarginTop: { xs: '56px', md: '64px' } }}
    >
        <Container maxWidth="lg">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, ease }}
            >
                <SectionHeading
                    eyebrow="Who you'd be working with"
                    title="Paul Tran, founder and principal engineer."
                    maxWidth={760}
                    sx={{ mb: { xs: 4, md: 5 } }}
                />

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                        columnGap: { md: 8 },
                        rowGap: 2.5,
                        alignItems: 'start',
                    }}
                >
                    <Typography sx={paragraphSx}>
                        Paul spent more than 15 years building software and leading
                        engineering teams, including at Amazon and Chewy, before founding
                        minneAI. He is an adjunct professor at St. Cloud State University,
                        where he teaches AI for Engineering Managers in the engineering
                        management master&rsquo;s programs and serves on the Electrical and
                        Computer Engineering industry advisory council.
                    </Typography>
                    <Typography sx={{ ...paragraphSx, color: '#111' }}>
                        You&rsquo;ll work directly with Paul throughout. When a build needs
                        more hands, he brings in a small bench of senior and principal
                        engineers from the largest tech companies, so the team scales to
                        fit the project and the point of contact never changes.
                    </Typography>
                </Box>
            </motion.div>
        </Container>
    </Box>
);

export default AboutSection;
